import { SecretVerificationRequest } from "./secret-verification.request";

export class UpdateTwoFactorWebAuthnDeleteRequest extends SecretVerificationRequest {
  id: number;
}
